import { createModel } from '@rematch/core';

import { RootModel } from '.';

export type ToastStatus = 'success' | 'error' | 'loading';

export type Toast = {
  id: string;
  status: ToastStatus;
  message?: string;
};

interface State {
  toasts: Toast[];
}

const initialState: State = {
  toasts: [],
};

export const toasts = createModel<RootModel>()({
  state: initialState,
  reducers: {
    create(state, payload: Toast) {
      return {
        ...state,
        toasts: [...state.toasts, payload],
      };
    },

    update(state, payload: Toast) {
      return {
        ...state,
        toasts: state.toasts.map((toast) => {
          if (toast.id !== payload.id) {
            return toast;
          }
          return { ...toast, ...payload };
        }),
      };
    },

    close(state, payload: { id: string }) {
      return {
        ...state,
        toasts: state.toasts.filter((toast) => toast.id !== payload.id),
      };
    },
  },

  effects: () => ({}),
});
